import letterHistory from './letterHistory';
import * as R from 'ramda';

export default function Letter(data){
    let letter = data || {};
    this.id = letter.id;
    this.contentUrl = letter.contentUrl;
    this.letterProgressStage = letter.letterProgressStage;
    this.sendingLimitDate = letter.sendingLimitDate;
    this.sentDate = letter.sentDate;
    this.optionalData = letter.optionalData;
    this.postClientSendingId = letter.postClientSendingId;
    this.postId = letter.postId;
    this.userId = letter.userId;
    this.writtingUserId = letter.writtingUserId;
    this.letterId = letter.letterId;
    this.userServiceId = letter.userServiceId;
    this.letterHistory = R.isNil(letter.letterHistory) ? [] : letter.letterHistory.map(c => new letterHistory(c));
}